import { Box, Grid, ListItem, Text, UnorderedList } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { EspdGuidingMessage } from "./EspdGuidingMessage";
import { EspdPreviewPart } from "./EspdPreviewPart";

export const EspdPreviewDelVI = () => {
  const { t } = useTranslation();
  return (
    <EspdPreviewPart eyebrow={t("Part VI")} title={t("Final declarations")} owner="fixed">
      <EspdGuidingMessage>
        {t("Standard text from EHF ESPD. The supplier consents upon submission.")}
      </EspdGuidingMessage>
      <UnorderedList spacing="1" pl="5" mb="4">
        <ListItem fontSize="sm">{t("Confirms that the information provided above is accurate.")}</ListItem>
        <ListItem fontSize="sm">{t("Consents that the contracting authority may require documentation for all criteria.")}</ListItem>
        <ListItem fontSize="sm">{t("Consents that the contracting authority may obtain information from public registers.")}</ListItem>
      </UnorderedList>
      <Grid templateColumns={{ base: "1fr", md: "1fr 1fr" }} columnGap="8" rowGap="2" mb="3">
        <FixedField label={t("Place")} placeholder={t("Filled in by the supplier")} />
        <FixedField label={t("Date")} placeholder={t("Filled in by the supplier")} />
      </Grid>
      <Text fontSize="xs" color="smMuted" fontStyle="italic">
        {t("Signed upon submission of the tender.")}
      </Text>
    </EspdPreviewPart>
  );
};

const FixedField = ({ label, placeholder }: { label: string; placeholder: string }) => (
  <Box py="1">
    <Text fontSize="xs" textTransform="uppercase" letterSpacing="wider" color="smMuted" mb="0.5">
      {label}
    </Text>
    <Text fontSize="sm" color="smMuted" fontStyle="italic">{placeholder}</Text>
  </Box>
);
